import { Action, createReducer, on } from '@ngrx/store';
import { PermSetActions } from '../actions';
import { PermSetStates } from '../states';
import { permSetAdapters, initialState } from '../states/perm-set.states';

export const permSetReducer = createReducer(
    initialState,

    on(PermSetActions.createPermSetSuccess, (state, action) => ({...state, updatePermSetListing: true})),
    on(PermSetActions.createPermSetFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update perm set
    on(PermSetActions.updatePermSetSuccess, (state, action) => ({...state, updatePermSetListing: true})),
    on(PermSetActions.updatePermSetFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update perm assignee target links
    on(PermSetActions.updatePermAssigneeTargetLinksFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // delete perm set
    on(PermSetActions.deletePermSetSuccess, (state, action) => ({...state, updatePermSetListing: true})),
    on(PermSetActions.deletePermSetFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // delete perm assignee target links
    on(PermSetActions.deletePermAssigneeTargetLinksFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    on(PermSetActions.setNewPermSet, (state, action) => ({...state, newPermSet: action.permSet})),
    on(PermSetActions.selectPermSet, (state, action) => ({...state, selectedPermSet: action.permSet})),
    on(PermSetActions.setPermTemplate, (state, action) => ({...state, selectedPermTemplate: action.permTemplate})),
    on(PermSetActions.selectPermSetLine, (state, action) => ({...state, selectedPermSetLine: action.permSetLine})),
    // on(PermSetActions.setPermSetLineChanges, (state, action) => ({...state, permSetLineChanges: action.lineChanges})),

    on(PermSetActions.setUpdatePermSetListing, (state, action) => ({...state, updatePermSetListing: action.update})),

    on(PermSetActions.selectGuid, (state, action) => ({...state, selectedGuid: action.guid})),
    on(PermSetActions.setRequiresUpdate, (state, action) => ({...state, requiresUpdate: action.update})),

    on(PermSetActions.saveViewState, (state, action) => ({...state, viewCache: action.cache}))
)

export function perm_set_reducer(state: PermSetStates | undefined, action: Action) {
    return permSetReducer(state.permSet, action);
}